<template>
  <v-container>
    <BaseList
      color="primary"
      :title="$route.meta.title"
      :section="$route.meta.section"
      :headers="headers"
      :items="activities"
      :loading="loading"
      :totalRows="totalRows"
      :buttons="{ search: true }"
      :actions="[]"
      @add="handleNew"
      @edit="handleEdit"
      @refresh="getData"
      @delete="handleDelete"
      @search="handleSearch"
      @options="handleOptions"
    >
      <template #custom-buttons-filters>
        <v-col cols="12" md="3">
          <v-select
            v-model="filter"
            label="Filtrar Por Elemento"
            placeholder="Filtrar Por Elemento"
            :items="filters"
            dense
            single-line
            hide-details
            @input="getData"
          />
        </v-col>
        <v-col cols="12" md="2">
          <DatePickerInput
            label="Filtrar Por Fecha"
            placeholder="Todos..."
            v-model="date"
            dense
            single-line
            hide-details
            clearable
            @input="getData"
          />
        </v-col>
        <v-col cols="12" md="1">
          <a
            :class="[exporting ? 'disabled-link' : '', 'd-flex flex-row align-center justify-center']"
            @click="handleExport()"
          >
            <v-icon
              class="mr-1 mr-sm-2"
              v-text="'mdi-microsoft-excel'"
              color="primary"
            />
            <span class="primary--text text-body-1">
              Exportar
            </span>
          </a>
        </v-col>
      </template>
      <template #item.description="{ item }">
        <span>
          {{ item.description }}
        </span>
      </template>
      <!-- UPDATED AT FIELD -->
      <template #item.causer_id="{ item }">
        <span>{{
          item.user ? `${item.user.first_name} ${item.user.last_name}` : ''
        }}</span>
      </template>
      <!-- Propiedades -->
      <template #item.properties="{ value }">
        <v-expansion-panels
          focusable
          accordion
          elevation="0"
          hover
          class="expansion-panel"
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-expansion-panel>
            <v-expansion-panel-header
              class="panel-header primary white--text font-weight-medium"
            >
              Ver Detalle
              <template v-slot:actions>
                <v-icon color="white">mdi-plus</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <span v-if="value.old">
                <br />
                <h4 class="primary--text">Registro Viejo</h4>
                <br />
                <ul>
                  <li v-for="i in getValues(value.old)" :key="i" v-html="i" />
                </ul>
              </span>
              <br />
              <h4 class="primary--text">Registro:</h4>
              <br />
              <ul>
                <li v-for="i in getValues(value.attributes)" :key="i" v-html="i" />
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="300"
          v-if="$vuetify.breakpoint.smAndDown"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              tile
              class="secondary"
              v-bind="attrs"
              v-on="on"
            >
              Ver Detalle
            </v-btn>
          </template>
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" class="font-weight-medium" dark>
                Propiedades
              </v-toolbar>
              <v-card-text>
                <span v-if="value.old">
                  <br />
                  <h4 class="primary--text">Registro Viejo</h4>
                  <br />
                  <ul>
                    <li v-for="i in getValues(value.old)" :key="i" v-html="i" />
                  </ul>
                </span>
                <br />
                <h4 class="primary--text">Registro:</h4>
                <br />
                <ul>
                  <li v-for="i in getValues(value.attributes)" :key="i" v-html="i" />
                </ul>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn class="secondary" text @click="dialog.value = false"
                  >Cerrar</v-btn
                >
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </template>
      <!-- UPDATED AT FIELD -->
      <template #item.updated_at="{ value }">
        <span>{{ value | date('DD/MM/YY - hh:mm:ss a') }}</span>
      </template>
      <!-- CREATE AT FIELD -->
      <template #item.created_at="{ value }">
        <span>{{ value | date('DD/MM/YY - hh:mm:ss a') }}</span>
      </template>
    </BaseList>
  </v-container>
</template>

<script>
import BaseList from '@/components/commons/BaseList'
import ActivityLogService from '@/services/activityLog'
import DatePickerInput from '@/components/commons/DatePickerInput.vue'
import { exportToExcel } from '@/utils/export'

export default {
  components: { DatePickerInput, BaseList },
  data() {
    return {
      options: {},
      loading: false,
      exporting: false,
      activities: [],
      totalRows: 0,
      search: '',
      headers: [
        { text: 'Descripción', value: 'description' },
        { text: 'Propiedades', value: 'properties', width: '30vw' },
        { text: 'Usuario', value: 'causer_id' },
        { text: 'Fecha de actividad', value: 'created_at', width: '14rem' }
      ],
      filter: null,
      date: null,
      filters: [
        {
          text: 'Todos',
          value: null
        },
        {
          text: 'Instrucciones Permanentes',
          value: 'filter[description]="ClientTransferInstructions"'
        },
        {
          text: 'Solicitudes de Transferencias',
          value: 'filter[description]="ClientTransferRequest"'
        },
        {
          text: 'Cuentas Asociadas',
          value: `filter[subject_type]="App\\\\Models\\\\Avobject"`
        },
        {
          text: 'Login',
          value: 'filter[description]="Login"'
        },
        {
          text: 'Parámetros',
          value: `filter[subject_type]="App\\\\Models\\\\Setting"`
        },
        {
          text: 'Preguntas de Seguridad',
          value: `filter[subject_type]="App\\\\Models\\\\Question"`
        },

        {
          text: 'Idiomas',
          value: `filter[subject_type]="App\\\\Models\\\\Language"`
        },
        {
          text: 'Traducciones',
          value: `filter[subject_type]="App\\\\Models\\\\Translation"`
        }
      ]
    }
  },
  methods: {
    async getData() {
      const { itemsPerPage, page, sortBy, sortDesc } = this.options
      let filterObj = null
      if (this.filter) {
        const parts = this.filter.split('=')
        const key = parts[0]
        const value = parts[1].replaceAll('"', '')
        filterObj = { [key]: value }
      }
      let filterDate = null
      if (this.date) {
        filterDate = { 'filter[created_at]': this.date }
      }

      this.loading = true
      try {
        const { data } = await ActivityLogService.fetch(
          { 'filter[query]': this.search, include: 'user', ...filterObj, ...filterDate },
          sortBy[0] ? sortBy[0] : '-created_at',
          sortDesc[0],
          page,
          itemsPerPage == -1 ? this.totalRows : itemsPerPage
        )
        this.activities = data.data
        this.totalRows = data.total
      } catch (e) {
        if (e.response.status !== 401) this.$dialog.notify.error(e.message)
      } finally {
        this.loading = false
      }
    },

    handleNew() {
      this.$router.push({ name: 'GenderIdentityCreate' })
    },

    handleEdit(item) {
      this.$router.push({
        name: 'GenderIdentityEdit',
        params: { id: item.id }
      })
    },

    async handleDelete(item) {
      const res = await this.$dialog.warning({
        text: '¿ Desea eliminar el registro ?'
      })

      if (!res) return false

      try {
        await ActivityLogService.delete(item.id)
        this.$dialog.notify.success('Registro eliminado con éxito.')
        await this.getData()
      } catch (e) {
        this.$dialog.message.error(e.title)
      }
    },

    handleOptions(options) {
      this.options = options
      this.getData()
    },

    handleSearch(value) {
      this.search = value
      this.getData()
    },

    handleExport() {
      this.exporting = true
      try {
        const data = this.activities.map(activity => {
          return {
            id: activity?.id,
            description: activity.description,
            properties: JSON.stringify(activity.properties?.attributes),
            user_id: activity.user?.id,
            user_full_name: activity.user?.first_name + ' ' + activity.user?.last_name,
            user_email: activity.user?.email,
            created_at: this.$date(activity.created_at).format('DD-MM-YYYY'),
            time: this.$date(activity.created_at).format('hh:mm:ss a')
          }
        })

        const date = this.$date().format('DD-MM-YY_HH:mm:ss')
        const fileName = `bitacora_${date}`

        exportToExcel(data, fileName)
      } catch (e) {
        console.log(e)
      } finally {
        this.exporting = false
      }
    },

    getValues(value) {
      delete value.created_at
      delete value.updated_at
      delete value.deleted_at

      let items = []
      Object.keys(value).forEach(el => {
        if (value[el]) {
          const title = `<strong>${el}:</strong>`
          const val = typeof value[el] === 'object' ? `${title} ${JSON.stringify(value[el])}` : `${title} ${value[el]}`
          items.push(val)
        }
      })

      return items
    },
    truncateIf(i) {
      if (i.length > 30) {
        let subStr = i.substring(0, 30)
        return subStr + '...'
      } else {
        return i
      }
    }
  }
}
</script>

<style scoped>
.panel-header {
  font-size: 14px;
}
.expansion-panel {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.disabled-link {
  pointer-events: none;
  cursor: default;
  color: grey;
}
</style>
